/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Machine } from './Machine';
import {
    MachineFromJSON,
    MachineFromJSONTyped,
    MachineToJSON,
    MachineToJSONTyped,
} from './Machine';

/**
 * 
 * @export
 * @interface PageResponseMachine
 */
export interface PageResponseMachine {
    /**
     * 
     */
    total?: number;
    /**
     * 
     */
    pageNumber?: number;
    /**
     * 
     */
    result?: Array<Machine>;
}

/**
 * Check if a given object implements the PageResponseMachine interface.
 */
export function instanceOfPageResponseMachine(value: object): value is PageResponseMachine {
    return true;
}

export function PageResponseMachineFromJSON(json: any): PageResponseMachine {
    return PageResponseMachineFromJSONTyped(json, false);
}

export function PageResponseMachineFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageResponseMachine {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'pageNumber': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'result': json['result'] == null ? undefined : ((json['result'] as Array<any>).map(MachineFromJSON)),
    };
}

export function PageResponseMachineToJSON(json: any): PageResponseMachine {
    return PageResponseMachineToJSONTyped(json, false);
}

export function PageResponseMachineToJSONTyped(value?: PageResponseMachine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'pageNumber': value['pageNumber'],
        'result': value['result'] == null ? undefined : ((value['result'] as Array<any>).map(MachineToJSON)),
    };
}

